// @ts-nocheck -- Build nélküli, kézzel írt plain JS sziget; a repo checkJs típusellenőrzését szándékosan kihagyjuk (lásd CLAUDE.md).
/*
 * Build nélküli, plain böngésző-JS. A repo oxlint konfigja a TS+build világra
 * van hangolva (stdlib/common wrapperek, no-semicolon, arrow-tiltás), ami itt
 * nem alkalmazható és valódi hibát nem fog (a correctness kategória eleve off).
 * Ezért erre a szigetre kikapcsoljuk. Ha később build kerül fölé, a fájlt
 * TS-re érdemes konvertálni és ezt a sort törölni. Lásd README.
 */
/* oxlint-disable */

/**
 * TudásFM – Dátum és névnap megjelenítése a hero szekcióban.
 *
 * Kiolvassa a mai dátumot, magyar formátumra alakítja, majd a
 * window.TUDASFM_NAMEDAYS globálisból kikeresi és kiírja a mai névnapot.
 * Nincs külső függőség, nincs build; klasszikus <script>-ként fut.
 */

const DAYS_HU = ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'];

const MONTHS_HU = [
  'január', 'február', 'március', 'április', 'május', 'június',
  'július', 'augusztus', 'szeptember', 'október', 'november', 'december',
];

function initNameday() {
  var dateEl = document.getElementById('today-date');
  var namedayEl = document.getElementById('today-nameday');

  if (dateEl === null && namedayEl === null) {
    return;
  }

  var now = new Date();
  var month = String(now.getMonth() + 1).padStart(2, '0');
  var day = String(now.getDate()).padStart(2, '0');
  var key = month + '-' + day;

  // Dátum magyar formátumban: "2026. július 28., kedd"
  if (dateEl !== null) {
    dateEl.textContent =
      now.getFullYear() + '. ' +
      MONTHS_HU[now.getMonth()] + ' ' +
      now.getDate() + '., ' +
      DAYS_HU[now.getDay()];
  }

  // Névnap
  if (namedayEl !== null) {
    var names = window.TUDASFM_NAMEDAYS && window.TUDASFM_NAMEDAYS[key];
    namedayEl.textContent = names || '–';
  }
}

initNameday();
